import { useBooleanState, type useToggleState } from '@cian/react-utils';
import { Button, CustomTooltip, IconMore16, type TPlacement, TooltipDesktop } from '@cian/ui-kit';

import { Children, type FC, type PropsWithChildren, useRef } from 'react';

import { stopPropagation } from '@/packages/utils/event';

import { ControlWrapper } from '../Controls';

import styles from './More.css';

type MoreContainerProps = {
  tooltipPlacement?: TPlacement;
  popoverPlacement?: TPlacement;
  popoverVisibilityState: ReturnType<typeof useToggleState>;
};

export const More: FC<PropsWithChildren<MoreContainerProps>> = props => {
  const { children, tooltipPlacement = 'left', popoverPlacement = 'left', popoverVisibilityState } = props;

  const tooltipVisibilityState = useBooleanState();
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <ControlWrapper visible={popoverVisibilityState.state} onClick={stopPropagation}>
      <TooltipDesktop
        open={tooltipVisibilityState.state && !popoverVisibilityState.state}
        placement={tooltipPlacement}
        theme="black"
        title="Ещё"
      >
        <Button
          beforeIcon={<IconMore16 />}
          data-testid="MoreControl"
          ref={buttonRef}
          size="XS"
          theme="stroke_secondary"
          onClick={popoverVisibilityState.toggle}
          onMouseOut={tooltipVisibilityState.setFalse}
          onMouseOver={tooltipVisibilityState.setTrue}
        />
      </TooltipDesktop>
      <CustomTooltip
        outside
        withoutPadding
        anchorRef={buttonRef}
        arrow={false}
        closeButton={false}
        content={
          <ul className={styles['list']}>
            {Children.map(children, item => {
              return (
                <li className={styles['item']} onClick={popoverVisibilityState.toggle}>
                  {item}
                </li>
              );
            })}
          </ul>
        }
        flip={false}
        maxWidth={180}
        open={popoverVisibilityState.state}
        placement={popoverPlacement}
        portal={false}
        preventOverflow={false}
        size="S"
        theme="white"
        onClose={popoverVisibilityState.toggle}
      />
    </ControlWrapper>
  );
};
